// extracted by mini-css-extract-plugin
export default {"container":"topIndustryPlayers_container__p6UUA","companyRevenue":"topIndustryPlayers_companyRevenue__fR5tx"};